import React from 'react';

const StarRating = ({ rating }) => {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <span key={i} className={`text-base ${i < rating ? 'text-yellow-400' : 'text-gray-200'}`}>
          ★
        </span>
      ))}
    </div>
  );
};

const TestimonialCard = ({ testimonial, onView, onEdit, onDelete }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden group border border-gray-100 flex flex-col">
      {/* Top Section */}
      <div className="p-5 flex-1">
        {/* Logo + Rating */}
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-100 border border-gray-200 flex-shrink-0">
            <img
              src={testimonial.logo}
              alt="logo"
              className="w-full h-full object-cover"
              onError={e => { e.target.src = 'https://via.placeholder.com/48'; }}
            />
          </div>
          <StarRating rating={testimonial.rating} />
        </div>

        {/* Heading */}
        <h3 className="text-sm font-bold text-gray-800 line-clamp-2 leading-snug mb-2">
          {testimonial.heading}
        </h3>

        {/* Content */}
        <p className="text-xs text-gray-500 line-clamp-3 leading-relaxed">
          "{testimonial.content}"
        </p>
      </div>

      {/* Author */}
      <div className="px-5 py-3 bg-gray-50 border-t border-gray-100">
        <p className="text-sm font-semibold text-gray-700">{testimonial.authorName}</p>
        {testimonial.jobRole && (
          <p className="text-xs text-gray-400 mt-0.5">{testimonial.jobRole}</p>
        )}
      </div>

      {/* Actions */}
      <div className="flex gap-2 p-4 border-t border-gray-100">
        <button
          onClick={onView}
          className="flex-1 py-2 rounded-lg bg-gray-50 hover:bg-gray-100 text-gray-600 text-sm font-medium transition"
        >
          👁️ View
        </button>
        <button
          onClick={onEdit}
          className="flex-1 py-2 rounded-lg bg-blue-50 hover:bg-blue-100 text-blue-600 text-sm font-medium transition"
        >
          ✏️ Edit
        </button>
        <button
          onClick={onDelete}
          className="flex-1 py-2 rounded-lg bg-red-50 hover:bg-red-100 text-red-500 text-sm font-medium transition"
        >
          🗑️
        </button>
      </div>
    </div>
  );
};

export default TestimonialCard;